module.exports = __webpack_public_path__ + "img/finances-icon.17a9a09c.svg";